export default {
  productType: 'ประเภทสินค้า',
  productName: 'ชื่อสินค้า',
  productCode: 'รหัสสินค้า',
  productBarcode: 'บาร์โค้ดสินค้า',
  productImage: 'รูปสินค้า',
  productCategory: 'หมวดหมู่สินค้า',
  productCategoryID: 'หมวดหมู่สินค้า',
  productCategoryName: 'หมวดหมู่สินค้า',
  productBrand: 'แบรนด์สินค้า',
  productWeight: 'น้ำหนัก',
  productLong: 'ความยาว',
  productWide: 'ความกว้าง',
  productHeight: 'ความสูง',
  productSubDetail: 'รายละเอียดสินค้า (ย่อ)',
  productDetail: 'รายละเอียดสินค้า',
  productTrack: 'แท๊กสินค้า',
  productStatusWebCatalog: 'เว็บแคตตาล็อค',
  productWarehouse: 'คลังสินค้า',
  productWarehouseID: 'คลังสินค้า',
  productWarehouseName: 'คลังสินค้า',
  productCost: 'ต้นทุน',
  productPrice: 'ราคาต่อหน่วย',
  productQTY: 'จำนวนสินค้า',
  productMinimumInventory: 'สินค้าคงคลังขั้นต่ำ'
};
